import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const cloudDownload: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M10-4.75a.22.22 0 0 0-.078-.172A.22.22 0 0 0 9.75-5H8v-2.75a.22.22 0 0 0-.078-.172A.22.22 0 0 0 7.75-8h-1.5a.24.24 0 0 0-.172.078A.2.2 0 0 0 6-7.75V-5H4.25a.24.24 0 0 0-.172.078A.2.2 0 0 0 4-4.75c0 .074.023.133.078.172l2.75 2.75c.04.055.098.078.172.078.07 0 .133-.023.188-.078l2.734-2.734A.3.3 0 0 0 10-4.75M15-3a2.93 2.93 0 0 1-.875 2.125A2.9 2.9 0 0 1 12 0H3.5Q2.061 0 1.031-1.031C.344-1.72 0-2.54 0-3.5q-.002-1.013.547-1.875a3.47 3.47 0 0 1 1.469-1.297A5 5 0 0 1 2-7q0-1.655 1.172-2.828T6-11c.813 0 1.555.23 2.234.688a3.85 3.85 0 0 1 1.47 1.796Q10.263-8.998 11-9q.826.001 1.406.594Q13-7.826 13-7q0 .598-.312 1.078a2.86 2.86 0 0 1 1.656 1.063Q15-4.044 15-3m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 11)"
    />
  ),
  svgProps: {
    height: "11",
    width: "15",
  }
};